import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { apiURL } from '../utilities/URLs'
import { affiliateData, company } from '../data/AffiliateData'

import setcLogo from '../assets/images/craig_setcLogo.png'
import '../css/loader.css'
import { useTheme } from '../ThemeContext'

export default function Login({ setLoggedIn }) {
  const navigate = useNavigate()
  const location = useLocation()
  const expired = location.state ? location.state.expired : false
  const { isDarkMode } = useTheme()

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const [loggingIn, setLoggingIn] = useState(false)
  const [loginStatus, setLoginStatus] = useState('')
  const [error, setError] = useState('')

  useEffect(() => {
    setLoggedIn(false)
  }, [])

  const handleLogin = async () => {
    if(email.length > 0 && password.length > 0) {
      setLoggingIn(true)
      const form = new FormData()
      form.append('loginInfo', JSON.stringify({
        email: email,
        password: password,
        companyId: company.companyId
      }))
      const loginResponse = await fetch(`${apiURL}/api/login`, {
        method: 'POST',
        body: form,
        credentials: 'include'
      })
      const loginData = await loginResponse.json()

      setLoggingIn(false)
      if(loginData.response.error) {
        setError(loginData.response.error)
        setTimeout(() => {
          setError('')
        }, 4000)
      } else {
        affiliateData.setAffiliateData(loginData.response)
        localStorage.setItem('affiliateAccessToken', loginData.response.accessToken)
        setLoggedIn(true)
        navigate('/affiliate/dashboard')
      }
    } else {
      setLoginStatus('Please Provide Both Email And Password.')
      setTimeout(() => [
        setLoginStatus('')
      ], 2000)
    }
  }

  return (
    <div className='flex flex-col items-center justify-center h-svh text-center font-mont'>
      <img className='w-60 mb-28' src={company.companyLogoURL} alt='setcLogo' />
      <div className={`w-full max-w-xs p-8 rounded-lg shadow mb-28 ${ isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
        <div className='mb-4'>
          <label htmlFor='email' className={`block mb-2 text-sm font-bold text-left ${isDarkMode ? 'text-white' : 'text-gray-700'}`}>
            Email
          </label>
          <input
            type='email'
            id='email'
            className={`w-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline ${isDarkMode && 'bg-gray-800 text-white'}`}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className='mb-6'>
          <label htmlFor='password' className={`block mb-2 text-sm font-bold text-left ${isDarkMode ? 'text-white' : 'text-gray-700'}`}>
            Password
          </label>
          <input
            type='password'
            id='password'
            className={`w-full px-3 py-2 mb-3 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline ${isDarkMode && 'bg-gray-800 text-white'}`}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <div className='flex justify-center'>
          <button onClick={() => handleLogin()} type='submit' className='px-4 py-2 font-bold text-white bg-primaryColor rounded hover:bg-primaryDarkColor focus:outline-none focus:shadow-outline'>
            Log In
          </button>
        </div>
        <p className={`resetPassword text-xs mt-5 text-center ${isDarkMode && 'text-white'}`}>Forgot Password? Reset it <span onClick={() => navigate('/affiliate/requestPasswordReset')} className='text-blue-600 cursor-pointer'>here</span></p>
        {loginStatus.length > 0 && (
          <p className='text-red-500 mt-5'>{loginStatus}</p>
        )}
        {expired && (
          <p className='text-red-500 mt-5'>Session Expired.</p>
        )}
        {loggingIn && (
          <div className='flex flex-row items-center justify-center gap-2 -mb-5'>
            <div className='loader ease-linear rounded-full border-[6px] border-t-[6px]  h-8 w-8 mt-4 mb-4'></div>
            <p className={isDarkMode && 'text-white'}>Logging In...</p>
          </div>
        )}
        {error.length > 0 && (
          <p className='text-red-700'>{error}</p>
        )}
      </div>
    </div>
  )
}